import React, { useState, useRef } from 'react';

import './sign-request-by-volume-upload-files.css';
import { ButtonHLPure, FormDateInput, LabelErrorPure, LabelHLPure, TextAreaHLPure } from '../../pures';
import { LocalStorageService, SignatureRequestService } from '../../../services';

const formatExample = `nombredearchivo001.pdf,correoA@electronico.com.mx,nombre del firmanteA, apellidos del firmarteA 
nombredearchivo002.pdf,correoB@electronico.com.mx,nombre del firmanteB, apellidos del firmarteB 
nombredearchivo003.pdf,correoC@electronico.com.mx,nombre del firmanteC, apellidos del firmarteC 
nombredearchivo004.pdf,correoD@electronico.com.mx,nombre del firmanteD, apellidos del firmarteD 
nombredearchivo005.pdf,correoE@electronico.com.mx,nombre del firmanteE, apellidos del firmarteE `;

const SignRequestByVolumeUploadFilesView = (props) => {
  /** @type {{t: import('i18next').TFunction}} */
  const { step, onHandleBack, onHandleNext, onHandleLoad, t } = props;
  const { next, back, load } = step;
  const [fileCsv, setFileCsv] = useState();
  const [textFileCsv, setTextFileCsv] = useState('');
  const inputFile = useRef(null);
  const fileReader = new FileReader();
  const [persistedCsv] = useState(props.csvJsonAsText);
  const [validCSV, setValidCSV] = useState(false)

  /** @type {{email: string, name: string, file: string}[][]} */
  const [csvJson, setCsvJSON] = useState()

  /** @type {{ idToken: string }} */
  const { idToken: token } = LocalStorageService.retrieveItem('token')

  /**
   * @param {string} str
   */
  const isNotValidCSVCharacters = (str) => {
    const cleanData = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const noSpecialCharsRegExp = new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ/;:¿?¡!()''&]+$/
    );

    return (cleanData !== str, noSpecialCharsRegExp.test(str))
  };

  const validateSigners = (users) => {
    const userEmail = (props.user && props.user.userMetaData && props.user.userMetaData.userMifirma && props.user.userMetaData.userMifirma.email) ? props.user.userMetaData.userMifirma.email : ''
    const usersToCompare = props.usersCollaborator.map(user => ({ ...user }))
    usersToCompare.push({ email: userEmail, status: true })


    const response = {
      allSignersAreValid: false,
      usersNotValid: []
    }
    response.allSignersAreValid = users.every(user => (usersToCompare.find(user2 => user2.email === user.email && user2.status)))
    if (!response.allSignersAreValid) {
      users.forEach(user => {
        const userActive = (usersToCompare.find(user2 => user2.email === user.email && user2.status))
        if (!userActive) response.usersNotValid.push(user.email)
      })
    }
    return { ...response }
  }

  const handleUpload = () => {
    inputFile.current.click();
  };

  const handleOnChange = (e) => {
    e.preventDefault()
    if (!e.target.files?.length) return
    setFileCsv(e.target.files[0])
    const csvFile = e.target.files[0]
    fileReader.onload = async (e) => {
      try {
        const text = e.target.result

        const isValidCSV = isNotValidCSVCharacters(text)
        if (isValidCSV) throw new Error('El CSV contiene carácteres especiales no admitidos.')

        const formData = new FormData()
        formData.append('fileCSV', csvFile)

        const response = await SignatureRequestService.readCsvFile(formData, token)
        if (response.statusCode !== 200) {
          switch (response.statusCode) {
            case 400: throw new Error('El formato del .csv no es el correcto.')
          }
          return
        }
        const { allSignersAreValid, usersNotValid } = validateSigners(response.data)
        if (!allSignersAreValid) {
          throw new Error(t('signatureRequestProfile.errors.signers.inactive', { collaborators: usersNotValid.toString() }))
        }
        setTextFileCsv(text);
        setValidCSV(true)
        setCsvJSON(response.data)
      } catch (e) {
        props.toggleErrorRequesting(true, e?.message)
        setTextFileCsv('');
        setValidCSV(false)
      }
    };

    fileReader.readAsText(csvFile);
  };

  const onHandleSubmit = (e) => {
    onHandleNext(e);
    onHandleLoad(csvJson, textFileCsv);
  }

  return (
    <div className='card-description-reliable'>
      <LabelHLPure
        text={t('signRequestByVolumeUploadFilesView.instructions')}
        fontSize={'16px'}
        showTooltip={false}
      />
      <input
        type='file'
        id='file'
        ref={inputFile}
        accept='.csv'
        onChange={handleOnChange}
        style={{ display: 'none' }}
      />
      {textFileCsv ? (
        <TextAreaHLPure
          valueTextData={textFileCsv || ''}
          readOnly={true}
        />
      ) : persistedCsv ? (
        <TextAreaHLPure
          valueTextData={persistedCsv || ''}
          readOnly={true}
        />
      ) : (
        <TextAreaHLPure
          valueTextData={formatExample || ''}
          readOnly={true}
        />
      )}
      <div className='signRequestByVolumeUploadFilesView-buttons'>
        <ButtonHLPure
          nameBtn={back}
          primary={false}
          onClickBtn={(event) => onHandleBack(event)}
        />
        <ButtonHLPure
          nameBtn={load}
          primary={false}
          onClickBtn={(event) => handleUpload(event)}
        />
        <ButtonHLPure
          nameBtn={next}
          primary={true}
          onClickBtn={(event) => onHandleSubmit(event)}
          disabled={!validCSV}
        />
      </div>
    </div>
  );
};

export default SignRequestByVolumeUploadFilesView;